import { Box, Chip } from "@mui/material";
import { colors } from "../../../theme/palette";
import typography from "../../../theme/typography";
import { useTranslation } from "react-i18next";

interface NetworkRolesProps {
  handleChangeChildTabValue: (newValue: number) => void;
  roleTab: number;
}

const NetworkRoles = ({ handleChangeChildTabValue, roleTab }: NetworkRolesProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
        whiteSpace: "nowrap",
        padding: "0 8px 8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "8px",
        }}
      >
        <Chip
          label={t("components.networkController.players")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChangeChildTabValue(1)}
          sx={{
            border: "none",
            padding: "1px 4px",
            ...(roleTab === 1 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
            color: roleTab === 1 ? colors.Green100 : colors.Dark600,
            background: roleTab === 1 ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("components.networkController.scouts")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChangeChildTabValue(2)}
          sx={{
            border: "none",
            padding: "1px 4px",
            ...(roleTab === 2 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
            color: roleTab === 2 ? colors.Green100 : colors.Dark600,
            background: roleTab === 2 ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("components.networkController.agents")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChangeChildTabValue(3)}
          sx={{
            border: "none",
            padding: "1px 4px",
            ...(roleTab === 3 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
            color: roleTab === 3 ? colors.Green100 : colors.Dark600,
            background: roleTab === 3 ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("components.networkController.coaches")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChangeChildTabValue(4)}
          sx={{
            border: "none",
            padding: "1px 4px",
            ...(roleTab === 4 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
            color: roleTab === 4 ? colors.Green100 : colors.Dark600,
            background: roleTab === 4 ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("components.networkController.others")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChangeChildTabValue(5)}
          sx={{
            border: "none",
            padding: "1px 4px",
            ...(roleTab === 5 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
            color: roleTab === 5 ? colors.Green100 : colors.Dark600,
            background: roleTab === 5 ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("components.networkController.entities")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChangeChildTabValue(6)}
          sx={{
            border: "none",
            padding: "1px 4px",
            ...(roleTab === 6 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
            color: roleTab === 6 ? colors.Green100 : colors.Dark600,
            background: roleTab === 6 ? colors.Green25 : "transparent",
          }}
        />
      </Box>
    </Box>
  );
};

export default NetworkRoles;
